import { render, staticRenderFns } from "./DownloadApp.vue?vue&type=template&id=747e32a2&scoped=true"
import script from "./DownloadApp.vue?vue&type=script&lang=ts"
export * from "./DownloadApp.vue?vue&type=script&lang=ts"
import style0 from "./DownloadApp.vue?vue&type=style&index=0&id=747e32a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "747e32a2",
  null
  
)

export default component.exports